module.exports = __webpack_public_path__ + "static/media/empty-heart.c03809c7.svg";